// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { Stack, Tooltip, Typography } from '@mui/material';

// relative
import { type AlarmImpact, formatCost, formatQuantity } from './alarmImpact';

type AlarmImpactSummaryProps = {
  impact: AlarmImpact;
};

export default function AlarmImpactSummary({
  impact,
}: AlarmImpactSummaryProps) {
  const { t } = useTranslation('energy-analysis');

  const items = [
    impact.monthlyQuantityDelta !== null && {
      key: 'quantity',
      label: t('portfolio.deepdive_alarms.impact.monthly_quantity_delta'),
      value: formatQuantity(impact.monthlyQuantityDelta, impact.unit),
    },
    impact.monthlyCost !== null && {
      key: 'cost',
      color: 'info.main',
      label: t('portfolio.deepdive_alarms.impact.monthly_cost'),
      value: formatCost(impact.monthlyCost),
    },
  ].filter((item) => item !== false);

  const priceSourceNote =
    impact.priceSource === 'spot_price_only'
      ? t('portfolio.deepdive_alarms.impact.price_source_spot_price_only')
      : '';

  return (
    <Tooltip title={priceSourceNote} placement="bottom-start">
      <Stack
        direction="row"
        spacing={4}
        flexWrap="wrap"
        useFlexGap
        sx={{ width: 'fit-content' }}
      >
        {items.map((item) => (
          <Stack key={item.key} direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" color="text.secondary">
              {item.label}
            </Typography>
            <Typography variant="subtitle1" fontWeight={600}>
              {item.value}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Tooltip>
  );
}
